import Reveal from "./Reveal";

/** Encabezado consistente para todas las secciones de la página. */
export default function SectionHead({
  eyebrow,
  title,
  lead,
  center = false,
  as: Tag = "h2",
  children,
}) {
  return (
    <Reveal className={`fsg-section-head ${center ? "is-center" : ""}`}>
      {eyebrow && <span className="fsg-eyebrow">{eyebrow}</span>}
      <Tag>{title}</Tag>
      {lead && <p>{lead}</p>}
      {children}
    </Reveal>
  );
}
